"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleMenu = function () {
    var hamburger = document.querySelector('.nav-toggler');
    var toggleClass = function () { return document.body.classList.toggle('menu-open'); };
    if (hamburger)
        hamburger.addEventListener('click', toggleClass);
};
exports.fixheader = function () {
    var header = document.getElementById('header');
    var outer = document.createElement('div');
    var inner = document.createElement('div');
    outer.style.overflow = 'scroll';
    window.addEventListener('resize', function (event) {
        calc();
    });
    calc();
    function calc() {
        document.body.appendChild(outer);
        outer.appendChild(inner);
        var scrollwidth = outer.offsetWidth - inner.offsetWidth;
        document.body.removeChild(outer);
        header.style.right = scrollwidth + 'px';
    }
};
